<template>

	<div class="row">
		<div class="col-12">
			<div class="form-container mb-3">
				<div class="form-title">Informações Adicionais</div>
				<div class="row">
					<div class="col-4" v-for="informacao in informacoes_adicionais" :key="informacao.id" style="font-size: small; padding-bottom: 5px;">
						<input type="checkbox" :value="informacao.id" @change="sincronizarInformacao(informacao.id, $event.target.checked)">&nbsp;{{ informacao.descricao }}
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<div class="col-12 form-container mb-3">
				<div class="form-title">Conciliação</div>
				<div class="row">
					<div class="col-12" style="font-size: small;" title="§ 5o O autor deverá indicar, na petição inicial, seu desinteresse na autocomposição, e o réu deverá fazê-lo, por petição, apresentada com 10 (dez) dias de antecedência, contados da data da audiência.">
						<input type="checkbox" v-model="manifestou_nao_interesse_conciliar" title="§ 5o O autor deverá indicar, na petição inicial, seu desinteresse na autocomposição, e o réu deverá fazê-lo, por petição, apresentada com 10 (dez) dias de antecedência, contados da data da audiência." @change="InteresseConciliar($event.target.checked)">&nbsp;Manifesto que NÃO tenho interesse em conciliar (art. 334, §5º CPC)
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="row" v-if="usuario_logado_administrador">
		<div class="col-12">
			<div class="col-12 form-container mb-3">
				<div class="form-title">Prazo da petição</div>
				<div class="row">
					<div class="col-12" style="font-size: small;" title="No sistema oficial do tribunal, o prazo é definido pelo Juiz ou pelo tipo da petição. Neste simulador somente os administradores/professores podem definir o prazo manualmente neste campo.">
						<input type="date" v-model="prazo_peticao" title="No sistema oficial do tribunal, o prazo é definido pelo Juiz ou pelo tipo da petição. Neste simulador somente os administradores/professores podem definir o prazo manualmente neste campo.">&nbsp;
						<br /><span style="font-size: smaller;"><i>No sistema oficial do tribunal, o prazo é definido pelo Juiz ou pelo tipo da petição. Neste simulador somente os administradores/professores podem definir o prazo manualmente neste campo.</i></span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<div class="col-12 form-container mb-3">
				<div class="row">
					<div class="col-12" style="font-size: small; text-align: center;">
						<a href="#" @click.prevent="" class="link_documentos">Adicionar mais Documentos</a>&nbsp;&nbsp;|&nbsp;&nbsp;
						<a href="#" @click.prevent="openEditor" class="link_documentos">Digitar Documento</a>&nbsp;&nbsp;|&nbsp;&nbsp;
						<a href="#" @click.prevent="" class="link_documentos">Opções Avançadas</a>
					</div>

					<documento-editor-component ref="documentoEditor"></documento-editor-component>

				</div>

				<div class="row">
					<div class="col-12 form-container mb-3" style="width: 80%; font-size: small; margin-left: auto; margin-right: auto;">
						<div class="form-title">[ - ]Documento 1</div>
						<div class="row">
							<div class="col-2">
								Arquivo: <span class="material-icons" style="font-size: small;" :title="uploadDocumentoTiposPermitidosTitle">
									help
								</span>
							</div>
							<div class="col-10">
								<input type="file" ref="fileInput"><br />
								<p v-if="$store.state.documentPathTemporario" style="font-weight: bold;">Petição digitada anexada.</p>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col-1">
								Tipo:
							</div>
							<div class="col-5" style="position: relative;">
								<input type="text" class="form-control form-control-sm" v-model="tipo_documentos_peticao_selecionado" @input="buscarDocumentosPeticao" />
								<ul v-if="tiposDocumentosPeticao.length" class="lista-autocomplete">
									<li v-for="tipo in tiposDocumentosPeticao" @click="selecionarTipoDocumento(tipo)" class="item-autocomplete">
										{{ tipo.descricao }}
									</li>
								</ul>
							</div>
							<div class="col-2">
								<a href="#" @click.prevent="buscarTodosDocumentosPeticao" style="color: black;">Listar Todos</a>
							</div>
							<div class="col-1">
								Sigilo:
							</div>
							<div class="col-3">
								<select class="form-control form-control-sm custom-select-sm custom-dropdown" v-model="nivel_sigilo_selecionado">
									<option :value="0">Sem Sigilo (Nível 0)</option>
									<option :value="1">Com Sigilo (Nível 1)</option>
								</select>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12" style="font-size: small; text-align: center;">
						<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; cursor: pointer; background-color: #007BFF;" @click="confirmarSelecaoDocumentos">
							<label style="color: white; vertical-align: middle; cursor: pointer;">Confirma seleção de documentos</label>
						</button>
					</div>
				</div>


				<div class="row mt-4">
					<div class="col-12" style="font-size: small;">
						<p style="text-align: center; font-weight: bold;">Documentos selecionados e ainda não utilizados em movimentação</p>
						<table class="table table-striped table-bordered mt-2 border">
							<thead>
								<tr class="text-center">
									<th scope="col" style="background-color: lightgrey; display: none;">id</th>
									<th scope="col" style="background-color: lightgrey;">Seq <span class="material-icons-outlined" style="font-size: small;">help</span></th>
									<th scope="col" style="background-color: lightgrey;">Formato</th>
									<th scope="col" style="background-color: lightgrey;">Nome Documento</th>
									<th scope="col" style="background-color: lightgrey;">Tamanho</th>
									<th scope="col" style="background-color: lightgrey;">Tipo Documento</th>
									<th scope="col" style="background-color: lightgrey;">Sigilo</th>
									<th scope="col" style="background-color: lightgrey;">Data Envio</th>
									<th scope="col" style="background-color: lightgrey;">Assoc. Assinaturas Digitais</th>
									<th scope="col" style="background-color: lightgrey;">Obs</th>
									<th scope="col" style="background-color: lightgrey;">Excluir</th>
								</tr>
							</thead>
							<tbody v-if="$store.state.processo.peticoes && $store.state.processo.peticoes.length > 0 && $store.state.processo.peticoes[0].documentos && $store.state.processo.peticoes[0].documentos.length > 0">
								<tr v-for="documento in $store.state.processo.peticoes[0].documentos">
									<td style="display: none;">{{ documento.id }}</td>
									<td style="text-align: left;">

										<button type="button" class="btn btn-sm" @click="moverDocumento(documento, 'cima')">
											<span class="material-icons-outlined">keyboard_arrow_up</span>
										</button>
										<button type="button" class="btn btn-sm" @click="moverDocumento(documento, 'baixo')">
											<span class="material-icons-outlined">expand_more</span>
										</button>
										{{ documento.order }}
									</td>
									<td style="text-align: left;">{{ documento.extensao_arquivo }}</td>
									<td style="text-align: left;">{{ documento.descricao }}</td>
									<td style="text-align: center;">{{ documento.tamanho_arquivo }} bytes</td>
									<td style="text-align: center;">
										<button type="button" class="btn btn-sm btn-light botao-grid" @click="">
											<label class="label_botao">Alterar</label>
										</button>
										{{ documento.tipo_documento_peticao.descricao.slice(0, 7) }}
									</td>
									<td style="text-align: center;">
										<button type="button" class="btn btn-sm btn-light botao-grid" @click="AlterarSigilo(documento)">
											<label class="label_botao">Alterar</label>
										</button>
										{{ documento.confidencial == 0 ? 'Sem Sigilo (Nível 0)' : 'Com Sigilo (Nível 1)' }}
									</td>
									<td style="text-align: center;">{{ formatDate(documento.updated_at) }}</td>
									<td style="text-align: center;">
										<button type="button" class="btn btn-sm btn-light botao-grid">
											<label class="label_botao">Associar</label>
										</button>(Opcional)
									</td>
									<td style="text-align: center;"><!-- OBS NÃO SABEMOS A INFORMAÇÃO QUE VAI AQUI --></td>
									<td style="text-align: center;">
										<button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerDocumento(documento.id)">
											<img :src='BASE_URL + "imagens/icons/assuntos_remover.png"' width="20px" />
										</button>
									</td>
								</tr>
							</tbody>
						</table>

						<hr />

					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	import axios from 'axios';
	import DocumentoEditorComponent from './DocumentoEditorComponent.vue';

	export default {
		components: {
			'documento-editor-component': DocumentoEditorComponent
		},
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				uploadDocumentoMaxMb: Number(window.Laravel.UPLOAD_DOCUMENTO_MAX_MB) || 10,
				informacoes_adicionais: [],
				informacoes_adicionais_selecionadas: [],
				manifestou_nao_interesse_conciliar: false,

				selecionar_arquivo: '',
				tipo_peticao_selecionado: '',
				nivel_sigilo_selecionado: 0,

				tipo_peticao_selecionado_id: '',
				tiposPeticao: [],

				tiposDocumentosPeticao: [],
				tipo_documentos_peticao_selecionado: '',
				tipo_documentos_peticao_selecionado_id: '',

				documentos: [],

				usuario_logado_administrador: false,
				prazo_peticao: null,
			};
		},
		computed: {
			uploadDocumentoTiposPermitidosTitle() {
				return `Tipos de arquivos permitidos:
						Documentos PDF e KML (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)
						Áudio: MP3, WMA e WAV (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)
						Imagens: JPEG, JPG, PNG e GIF (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)
						Vídeos: MP4, WMV, MPG e MPEG (Tamanho máximo = ${this.uploadDocumentoMaxMb}MB)`;
			},
		},
		methods: {
			uploadDocumentoMaxSizeBytes() {
				return this.uploadDocumentoMaxMb * 1024 * 1024;
			},
			uploadDocumentoMaxMessage() {
				return `Em conformidade com o sistema oficial, só são permitidos arquivos com tamanho máximo de ${this.uploadDocumentoMaxMb} MB`;
			},
			uploadDocumentoErrorMessage(error) {
				if (error.response && error.response.status === 422 && error.response.data && error.response.data.message) {
					return error.response.data.message;
				}

				return "Erro ao adicionar o arquivo!";
			},
			// #region métodos IA
			retornaDadosParaIA() {
				let conteudoTexto = "";

				if (this.$refs.documentoEditor) {
					conteudoTexto = this.$refs.documentoEditor.editorData || this.$refs.documentoEditor.content || "";
					if (!conteudoTexto && this.$refs.documentoEditor.editorInstance) {
						conteudoTexto = this.$refs.documentoEditor.editorInstance.getData() || "";
						return conteudoTexto;
					}
				}

				if (!conteudoTexto) {
					conteudoTexto = this.$store.state.processo.teor_peticao || "";
				}

				let listaArquivos = [];
				if (
					this.$store.state.processo.peticoes &&
					this.$store.state.processo.peticoes.length > 0 &&
					this.$store.state.processo.peticoes[0].documentos
				) {
					listaArquivos = this.$store.state.processo.peticoes[0].documentos.map(doc => {
						return {
							id: doc.id,
							hash_name: doc.nome_arquivo_servidor || doc.hash_name || doc.caminho || doc.descricao,
							path: doc.caminho || doc.path,
							mime: doc.tipo_documento?.descricao || doc.mime_arquivo || "application/pdf", // fallback
							isPeticao: false
						};
					});
				}

				return {
					conteudo_editor: conteudoTexto,
					uploadedFiles: listaArquivos
				};
			},
			// #endregion
			openEditor() {
				this.$refs.documentoEditor.openEditor();
			},
			formatDate(value) {
				if (value) {
					const date = new Date(value);
					const day = date.getDate().toString().padStart(2, '0');
					const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
					const year = date.getFullYear();
					const hours = date.getHours().toString().padStart(2, '0');
					const minutes = date.getMinutes().toString().padStart(2, '0');
					const seconds = date.getSeconds().toString().padStart(2, '0');
					return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
				}
				return '';
			},
			AlterarSigilo(documento) {
				documento.confidencial = documento.confidencial === 0 ? 1 : 0;
				const response = axios.post(this.BASE_URL + 'processo-alterar-sigilo-documento', {
					documento_id: documento.id,
					confidencial: documento.confidencial
				});
			},

			async moverDocumento(documentoClicado, direcao) {
				const documentos = [...this.$store.state.processo.peticoes[0].documentos];
				const index = documentos.findIndex(doc => doc.id === documentoClicado.id);
				if (index === -1) return; // Documento não encontrado

				let newIndex = index + (direcao === 'cima' ? -1 : 1);
				if (newIndex < 0 || newIndex >= documentos.length) return; // Checa limites

				// Atualiza os valores de 'order' para refletir a nova ordem
				documentos[index].order = newIndex + 1;
				documentos[newIndex].order = index + 1;

				// Reordena o array de documentos baseado no novo 'order'
				documentos.sort((a, b) => a.order - b.order);

				// Atualiza a lista de documentos no Vuex store (assumindo que você tenha uma mutation configurada para isso)
				this.$store.commit('atualizarDocumentos', documentos);
				const response_docs = await axios.post(`${this.BASE_URL}atualizar-ordem-documentos`, { documentos });
				// Aqui você pode adicionar chamada de API para atualizar a ordem no backend
			},
			async confirmarSelecaoDocumentos() {
				if (this.tipo_documentos_peticao_selecionado_id == '') {
					alert("Nenhum tipo selecionado.");
					return;
				}

				let documentPath = this.$store.state.documentPathTemporario;


				if (!documentPath) { //Se o arquivo não foi digitado, ele precisa estar selecionado no campo input

					// Pega o arquivo do input
					const file = this.$refs.fileInput.files[0];

					if (!file) {
						alert("Por favor, selecione um arquivo ou digite a petição em 'Digitar Documento'.");
						return;
					}

					// Validações dos tipos de arquivos e tamanhos
					const validTypes = ['application/pdf', 'application/vnd.google-earth.kml+xml', 'audio/mpeg', 'audio/wma', 'audio/wav', 'image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/x-ms-wmv', 'video/mpeg'];
					const maxSize = this.uploadDocumentoMaxSizeBytes();

					if (!validTypes.includes(file.type)) {
						alert("Tipo de arquivo não permitido.");
						return;
					}

					if (file.size > maxSize) {
						alert(this.uploadDocumentoMaxMessage());
						return;
					}

				}


				let processoId = this.$store.state.processo.id;

				if (!this.$store.state.processo.peticoes) {
					//Ainda não tem petição nenhum nesse processo. Então tem que gerar a petição.
					let nova_peticao = {
						id: '',
						processoId: processoId,
						tipo_id: this.tipo_documentos_peticao_selecionado_id,
						numero: '',
						descricao: this.tipo_peticao_selecionado,
						pedido_liminar: 0,
						created_por_user_id: this.$store.state.processo.criado_por,
						sigilo: this.nivel_sigilo_selecionado,
						documento: documentPath || '',
						prazo_peticao: this.prazo_peticao || null,
					}


					const response = await axios.post(this.BASE_URL + 'criar-peticao', nova_peticao);
					this.$store.commit('setPeticao', response.data);
					alert("Petição criada com sucesso!");
				}

				let formData = new FormData();
				formData.append('peticao_id', this.$store.state.processo.peticoes[0].id); // Ajuste conforme necessário
				formData.append('processo_id', processoId); // Supondo que `processoId` esteja disponível
				formData.append('tipo_documentos_peticao_selecionado_id', this.tipo_documentos_peticao_selecionado_id);
				formData.append('nivel_sigilo_selecionado', this.nivel_sigilo_selecionado);
				let created_por_user_id = this.$store.state.processo.peticoes[0].created_por_user_id;
				formData.append('created_por_user_id', created_por_user_id);

				if (documentPath) {
					// Caso a petição tenha sido digitada
					formData.append('documentPath', documentPath); // Caminho do arquivo no servidor
					formData.append('peticao_digitada', 1); // Indica que a petição foi digitada
					// Não há necessidade de incluir `tamanho_arquivo`, `mime_arquivo` e `extensao_arquivo` pois o arquivo já está no servidor
				} else {
					// Caso o arquivo tenha sido selecionado através do input
					const file = this.$refs.fileInput.files[0];
					formData.append('documento', file);
					formData.append('peticao_digitada', 0);
					formData.append('tamanho_arquivo', file.size);
					formData.append('mime_arquivo', file.type);
					let extensao_arquivo = file.name.split('.').pop();
					formData.append('extensao_arquivo', extensao_arquivo);
				}

				// Dentro do try block da sua função confirmarSelecaoDocumentos, após o upload
				try {
					const responseUpload = await axios.post(this.BASE_URL + 'upload-documento', formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					});
					// Atualiza o Vuex state
					this.$store.commit('addDocumentoToPeticao', { peticaoIndex: 0, documento: responseUpload.data });

					alert("Arquivo adicionado com sucesso!");
					this.tipo_documentos_peticao_selecionado = '';
					this.tipo_documentos_peticao_selecionado_id = '';
					this.$store.commit('clearDocumentPathTemporario'); //Limpa a variável da petição temporária.

					if (!documentPath) {
						// Limpa o input de arquivo apenas se um arquivo foi selecionado manualmente
						this.$refs.fileInput.value = '';

					}
				} catch (error) {
					console.error("Erro ao adicionar o arquivo:", error);
					alert(this.uploadDocumentoErrorMessage(error));
				}
			},
			async removerDocumento(documentoId) {
				if (window.confirm('Tem certeza que deseja remover este documento?')) {
					try {
						const response = await axios.delete(`${this.BASE_URL}processo-remover-documento/${documentoId}`);

						const documentos = this.$store.state.processo.peticoes[0].documentos;
						const indexRemovido = documentos.findIndex(doc => doc.id === documentoId);
						if (indexRemovido !== -1) {
							// Captura o valor de order do documento removido
							const orderRemovido = documentos[indexRemovido].order;

							// Remove o documento do array
							documentos.splice(indexRemovido, 1);

							// Ajusta o valor de order para os documentos seguintes
							documentos.forEach(doc => {
								if (doc.order > orderRemovido) {
									doc.order -= 1;
								}
							});

							// Opcionalmente, reordena os documentos por segurança
							documentos.sort((a, b) => a.order - b.order);

							// Atualiza a lista de documentos no Vuex store
							this.$store.commit('atualizarDocumentos', documentos);

							const response_docs = await axios.post(`${this.BASE_URL}atualizar-ordem-documentos`, { documentos });

							// Aqui você pode adicionar uma chamada de API para atualizar a ordem no backend
						}
					} catch (error) {
						console.error('Erro ao remover o documento:', error);
					}
				}
			},


			async buscarDocumentosPeticao() {
				if (this.tipo_documentos_peticao_selecionado.length > 1) {
					try {
						const response = await axios.get(this.BASE_URL + `processo/buscar-documentos-peticao?query=${this.tipo_documentos_peticao_selecionado}`);
						this.tiposDocumentosPeticao = response.data;
					} catch (error) {
						console.error(error);
						// Tratamento de erro
					}
				} else {
					this.tiposDocumentosPeticao = [];
				}
			},
			async buscarTodosDocumentosPeticao() {
				try {
					const response = await axios.get(this.BASE_URL + 'processo/buscar-documentos-peticao?all=true');
					this.tiposDocumentosPeticao = response.data;
				} catch (error) {
					console.error(error);
				}
			},
			async buscarTipoPeticao() {
				if (this.tipo_peticao_selecionado.length > 1) {
					try {
						const response = await axios.get(this.BASE_URL + `processo/buscar-tipo-peticao?query=${this.tipo_peticao_selecionado}`);
						this.tiposPeticao = response.data;
						console.log(this.tiposPeticao);
					} catch (error) {
						console.error(error);
						// Tratamento de erro
					}
				} else {
					this.tiposDocumentosPeticao = [];
				}
			},
			selecionarTipoDocumento(tipo) {
				this.tipo_documentos_peticao_selecionado = tipo.descricao;
				this.tipo_documentos_peticao_selecionado_id = tipo.id;
				this.tiposDocumentosPeticao = [];
			},
			async buscarTodosTipos() {
				try {
					const response = await axios.get(this.BASE_URL + 'processo/buscar-tipo-peticao?all=true');
					this.tiposPeticao = response.data;
				} catch (error) {
					console.error(error);
				}
			},
			selecionarTipo(tipo) {
				this.tipo_peticao_selecionado = tipo.descricao;
				this.tipo_peticao_selecionado_id = tipo.id;
				this.tiposPeticao = [];
			},
			CarregarInformacoesAdicionais() {
				axios.get(this.BASE_URL + 'buscar/informacoes_adicionais')
					.then(response => {
						this.informacoes_adicionais = response.data;
					})
					.catch(error => {
						console.error('Erro ao buscar informações os assuntos:', error);
					});
			},
			InteresseConciliar() {
				try {
					let processoId = this.$store.state.processo.id;
					const response = axios.post(this.BASE_URL + 'processo_atualiza_conciliar', {
						processoId: processoId,
						manifestou_nao_interesse_conciliar: this.manifestou_nao_interesse_conciliar,
					});


					this.$store.commit('setProcessoTemInteresseConciliar', this.manifestou_nao_interesse_conciliar);

				} catch (error) {
					console.error('Erro ao atualizar o interesse de conciliação.', error);
				}
			},
			async sincronizarInformacao(info_id, isChecked) {
				try {
					let processoId = this.$store.state.processo.id;

					const response = await axios.post(this.BASE_URL + 'processo-informacoes_adicionais/sincronizar', {
						processoId: processoId,
						info_id: info_id,
						checked: isChecked
					});

					this.informacoes_adicionais_selecionadas = response.data;
					this.$store.commit('setProcessoInformacoesAdicionais', this.informacoes_adicionais_selecionadas);

					// Trate aqui a resposta do servidor se necessário
				} catch (error) {
					console.error('Erro ao sincronizar informação:', error);
					// Trate aqui o erro, caso ocorra
				}
			},
			async UsuarioAdministrador() {
				try {
					const response = await axios.get(this.BASE_URL + 'usuario_administador');
					this.usuario_logado_administrador = response.data.is_admin;
				} catch (error) {
					console.error('Erro ao verificar se o usuário é administrador:', error);
					return false;
				}
			},
		},
		mounted() {
			this.CarregarInformacoesAdicionais();
			this.UsuarioAdministrador();
		},
		computed: {


		}
	};
</script>

<style scoped>

	.form-container {
		border: 1px solid gray;
		/* Borda fina cinza */
		padding: 10px;
		position: relative;
		/* Posição relativa para o posicionamento do título */
		margin-top: 5px;
		/* Espaçamento superior para visualização do título */
		margin-left: 5px;
		margin-right: 5px;
		border-radius: 5px;
		background-color: #FFFFFF;
	}

	.form-title {
		position: absolute;
		/* Posicionamento absoluto do título */
		top: -15px;
		/* Posiciona o título acima da borda */
		left: 10px;
		/* Espaçamento da esquerda para o título */
		background: white;
		/* Fundo branco para o título */
		padding: 0 1px;
		/* Espaçamento interno do título */
		font-weight: bold;
	}

	.link_documentos {
		text-decoration: none;
		font-weight: bold;
	}

	.form-control-smaller {
		height: calc(1.5em + 0.5rem + 2px);
		padding: 0.25rem 0.5rem;
	}


	.lista-autocomplete {
		position: absolute;
		z-index: 1000;
		/* Assegura que a lista fique acima de outros conteúdos */
		width: 100%;
		/* Faz a lista ocupar toda a largura do contêiner pai */
		background-color: #fff;
		/* Ou qualquer cor que se adeque ao seu design */
		box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
		/* Adiciona sombra para um efeito de elevação */
		max-height: 300px;
		/* Limita a altura da lista e torna-a rolável */
		overflow-y: auto;
		/* Adiciona barra de rolagem vertical se necessário */
		border: 1px solid #ccc;
		/* Adiciona uma borda sutil (opcional) */
		border-top: none;
		/* Remove a borda superior para se fundir melhor com o campo de entrada */
		list-style-type: none;
	}

	.item-autocomplete {
		padding: 2px;
		cursor: pointer;
	}

	.item-autocomplete:hover {
		background-color: #f5f5f5;
		/* Muda a cor de fundo ao passar o mouse */
	}


	.botao-grid {
		margin-right: 2px;
		width: 90px;
		cursor: pointer;
	}

	.label_botao {
		color: #007BFF;
		vertical-align: middle;
		cursor: pointer;
	}

</style>
